// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1rf7W","vLegacy":"SelectSecondary_vLegacy__NJrTK","error":"SelectSecondary_error__2HfVT","disabled":"SelectSecondary_disabled__VyOxl"};